<template>
  <div class="jobs_page">

    <!-- grey intro -->
    <div class="bg-site-light pt-4 pb-4 mb-4">
      <div class="container-fluid px-5">
        <div class="d-flex flex-column flex-sm-row justify-content-sm-between align-items-sm-end py-2 text-center text-sm-left">
          <div class="flex-sm-fill">
            <h1 class="h3 font-w700 mb-2">
              Integrations
            </h1>
            <h2 class="h6 font-w500 text-muted mb-0">
              Manage your shop-integrations
            </h2>
          </div>
          <div class="mt-3 mt-sm-0 ml-sm-3 flex-shrink-0">
            <!--
            <a href="javascript:void(0)" class="btn btn-outline-secondary mr-1"><b-icon icon="plus-square-fill"></b-icon> New Order</a>
            <a href="javascript:void(0)" class="btn btn-secondary"><b-icon icon="gear-fill"></b-icon></a>
            -->
          </div>
        </div>
      </div>
    </div>

    <div class="px-md-3">
      <div class="container-fluid pt-3 pb-1 mb-5 bg-white shadow">
        <IntegrationTable :filters="filters" />
      </div>
    </div>

  </div>
</template>



<script>
import { mapGetters } from 'vuex'

import IntegrationTable from '@/components/IntegrationTable/IntegrationTable'

export default {
  components: {
    IntegrationTable
  },

  data() {
    return {
      filters: {},
    }
  },

  created() {
    // let query = Object.assign({}, this.$route.query);
    // if ( query?.status ) {
    //   this.filters.status = query.status;
    //   delete query.status;
    //   this.$router.replace({ query });
    // }
  },

  computed: {
    ...mapGetters([
      'timestampAsDate',
      'countryByCode',
    ]),
    ...mapGetters('user', [
      'userHasRole',
    ]),
  },

  methods: {}
}
</script>

<style lang="scss">
</style>